export interface ISubscription {
  id: string;
  name: string;
  durationType: SubscriptionDurationTypesEnum;
  duration: number;
  isTrial: boolean;
  isVisible: boolean;
  price: number;
  description: string;
  credits: number;
}

export enum SubscriptionDurationTypesEnum {
  day = "day",
  week = "week",
  month = "month",
  year = "year",
}

export interface IModelForBuyingSubscription {
  userId: string;
  subscriptionId: string;
  paymentMethodId: number;
  loyaltyExchangeId: number | null;
  redirectUrl: string;
}

export interface IModelForChangingSubscription {
  userId: string;
  paymentMethodId: string;
  subscriptionId: string;
  userSubscriptionId: string;
}
